import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Search, Trash2, UserPlus, CheckCircle2 } from "lucide-react";
import api, { formatError } from "../lib/api";
import { Input } from "./ui/input";

export const RosterManager = () => {
  const [names, setNames] = useState([]);
  const [q, setQ] = useState("");
  const [newName, setNewName] = useState("");

  const load = () => api.get("/admin/roster").then(({ data }) => setNames(data)).catch((e) => toast.error(formatError(e)));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/roster", { name: newName });
      toast.success("Name added");
      setNewName("");
      load();
    } catch (err) { toast.error(formatError(err)); }
  };
  const remove = async (n) => {
    if (!window.confirm(`Remove ${n.name} from the list?`)) return;
    await api.delete(`/admin/roster/${n.id}`);
    load();
  };

  const shown = names.filter((n) => n.name.toLowerCase().includes(q.toLowerCase()));
  const done = names.filter((n) => n.entries > 0).length;

  return (
    <div className="space-y-4" data-testid="roster-manager">
      <form onSubmit={add} className="flex gap-2">
        <Input value={newName} onChange={(e) => setNewName(e.target.value)} placeholder="Add a name to the list" className="h-10 bg-white" data-testid="roster-add-input" />
        <button type="submit" disabled={newName.trim().length < 2} data-testid="roster-add-button" className="shrink-0 inline-flex items-center gap-1.5 px-4 rounded-full bg-stone-900 text-stone-50 text-sm font-semibold disabled:opacity-50"><UserPlus className="h-4 w-4" />Add</button>
      </form>
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-stone-400" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search names" className="pl-9 h-10 bg-white" data-testid="roster-search-input" />
      </div>
      <p className="text-sm text-stone-600" data-testid="roster-summary">{names.length} names • <span className="font-semibold text-stone-900">{done} have contributed</span> • {names.length - done} pending</p>
      <div className="bg-white border border-stone-300/70 rounded-lg divide-y divide-stone-200 max-h-[32rem] overflow-y-auto">
        {shown.map((n) => (
          <div key={n.id} className="flex items-center gap-3 px-4 py-2.5" data-testid={`roster-row-${n.id}`}>
            <span className="flex-1 min-w-0 truncate font-semibold text-sm">{n.name}</span>
            {n.source === "self" && <span className="text-[10px] uppercase tracking-wide text-stone-500">self-added</span>}
            {n.entries > 0 && <span className="inline-flex items-center gap-1 text-xs font-semibold text-teal-700"><CheckCircle2 className="h-3.5 w-3.5" />{n.entries}</span>}
            <button onClick={() => remove(n)} data-testid={`roster-delete-${n.id}`} className="p-1.5 rounded text-stone-400 hover:text-rose-600 hover:bg-rose-50"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
    </div>
  );
};
